// extracted by mini-css-extract-plugin
export var aiStarIcon = "_co-4";
export var closeButton = "_co-6";
export var dismissButton = "_co-3";
export var editImageWithAiContainer = "_co-8";
export var imageUploadWrapper = "_co-7";
export var misspelledWord = "_co-5";
export var spellCheckContainer = "_co-2";
export var spin = "_co-1";
export var spinning = "_co-0";